<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  severity: {
    type: String,
    default: null //info, warning, danger, success
  },
  emphasize: {
    type: Boolean,
    default: null
  },
  modal: {
    type: String,
    default: null
  }
});

const container = ref();
const lastModal = ref();
const isVisible = ref();

onMounted(() => {
  lastModal.value = props.modal;
  shiftModalWindow();
});

onUnmounted(() => {
  unshiftModalWindow();
});

watch(props.modal, (id) => {
  if (id) {
    lastModal.value = id;
    shiftModalWindow();
  }
  else {
    unshiftModalWindow();
    lastModal.value = null;
  }
});

function shiftModalWindow() {
  let id = lastModal.value;
  if (!id) {
    return;
  }

  let modal = document.getElementById(id);
  if (!modal) {
    return;
  }

  modal.classList.add("bg-warning-alert");

  if (props.emphasize) {
    let background = modal.querySelector(".bg-opacity-50");
    if (background) {
      background.classList.add("bg-blink");
      if (props.severity) {
        background.classList.add("banner-" + props.severity);
      }
    }
  }

  let win = modal.querySelector(".relative.w-full.h-full");
  if (win) {
    let rect = container && typeof container.getBoundingClientRect == "function" ? container.getBoundingClientRect() : { height: 95 };
    win.style.paddingTop = rect.height + "px";
  }

  isVisible.value = true;
}

function unshiftModalWindow() {
  let id = lastModal.value;
  if (!id) {
    return;
  }

  let modal = document.getElementById(id);
  if (!modal) {
    return;
  }

  modal.classList.remove("bg-warning-alert");

  let background = modal.querySelector(".bg-opacity-50");
  if (background) {
    background.classList.remove("bg-blink");
  }

  let win = modal.querySelector(".relative.w-full.h-full");
  if (win) {
    win.style.paddingTop = null;
  }

  isVisible.value = false;
}
</script>

<template>
  <Teleport to="body">
    <div ref="container" class="bg-warning-banner" :class="severity ? 'banner-' + severity : ''">
      <slot />
    </div>
  </Teleport>
</template>

<style scoped>
</style>
